import React from "react";
import "../css/career.css";

const Careers = () => {
  const jobListings = [
    {
      title: "no current oppotunities as for now",
     
    },
   
  ];

  return (
    <div className="careers-container">
      <h1 className="careers-header">Career Opportunities</h1>

      <section className="careers-section">
        <h2 className="careers-subheader">Current Job Openings</h2>
        <ul className="careers-list">
          {jobListings.map((job, index) => (
            <li key={index} className="careers-list-item">
              <h3>{job.title}</h3>
              <p>
                <strong>Location:</strong> {job.location}
              </p>
              <p>{job.description}</p>
              <a href={job.applyLink} className="careers-link">
                Apply Now
              </a>
            </li>
          ))}
        </ul>
      </section>

      <section className="careers-section">
        <h2 className="careers-subheader">How to Apply</h2>
        <p>
          To apply for any of the positions listed above, click the "Apply Now"
          link next to the job title. You will be directed to the job
          application page for detailed instructions. For more information,
          contact our HR department at {" "}
          <strong>
            <a href="mailto:hr@lesothonurses.org" className="careers-link">
              hr@lesothonurses.org
            </a>
          </strong>
          .
        </p>
      </section>
    </div>
  );
};

export default Careers;
